import http from '@/http'
import Bill from '@/store/models/admin/Bill'

const API_PATH = 'organizations/:organizationId/admin/account/bills/'

const configureApiPath = ({ organizationId }) => {
  return API_PATH.replace(':organizationId', organizationId)
}

const state = {
}

const getters = {
  getDownloadPDFURL: (state, getters, rootState, rootGetters) => (id) => {
    return configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id }) + id + '/download_pdf'
  }
}

const mutations = {
}

const actions = {
  async index({ commit, rootGetters }) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    await http.get(apiPath).then(response => {
      Bill.deleteAll()
      Bill.insert({
        data: response.data.data.map(bill => bill.attributes)
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async show({ commit, rootGetters }, id) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    await http.get(apiPath + id).then(response => {
      Bill.insert({
        data: Object.assign(response.data.data.attributes, {
          invoices: response.data.included.filter(resource => resource.type === 'invoice').map(invoice => invoice.attributes),
          payments: response.data.included.filter(resource => resource.type === 'payment').map(payment => payment.attributes)
        })
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
